import Component from '../abstracts/Component';

export default class EditorialPromoComponent extends Component {

  get COMPONENTNAME() {
    return 'EditorialPromoComponent';
  }

  constructor(compEl) {
    super(compEl);
  }

  toggleText() {
    const additionalText = this.$component.querySelector('.additional-text');
    const toggleText = this.$component.querySelector('.toggle-text');
    const isOpen = toggleText.dataset.open === "true";

    $(additionalText).toggle();

    toggleText.innerHTML = isOpen ? toggleText.dataset.readMore : toggleText.dataset.readLess;
    toggleText.dataset.open = isOpen ? "false" : "true";
  }


  bindEvents() {
    this.$component.querySelector('.w-read-more').addEventListener('click', () => this.toggleText());
  }

  render() {
    this.bindEvents();
  }
}
